/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Errors_Modaltitle1Inputs */

const en_errors_modaltitle1 = /** @type {(inputs: Errors_Modaltitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong`)
};

/**
* | output |
* | --- |
* | "Something went wrong" |
*
* @param {Errors_Modaltitle1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const errors_modaltitle1 = /** @type {((inputs?: Errors_Modaltitle1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Errors_Modaltitle1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_errors_modaltitle1(inputs)
});
export { errors_modaltitle1 as "errors_modalTitle" }